import { addLocaleData } from "react-intl";
import viLang from "./entries/vi-VN";
import jpLang from "./entries/ja-JP";
import enLang from "./entries/en-US";
import esLang from "./entries/es-ES";
import enRtlLang from "./entries/en-US-rtl";
import zhLang from "./entries/zh-CN";
import ruLang from "./entries/ru-RU";

const AppLocale = {
  vi: viLang,
  jp: jpLang,
  en: enLang,
  es: esLang,
  enrtl: enRtlLang,
  zh: zhLang,
  ru: ruLang,
};
addLocaleData(AppLocale.vi.data);
addLocaleData(AppLocale.jp.data);
addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.es.data);
addLocaleData(AppLocale.enrtl.data);
addLocaleData(AppLocale.zh.data);
addLocaleData(AppLocale.ru.data);

export default AppLocale;
